import React from 'react';
import CardTerminals from "../../../CardTerminals";

import WrapperWithLoading from '../../../../../../../dumb/WrapperWithLoading';
import {LINK_TERMINALS_BUY, LINK_TERMINALS_LIST} from "../../../../../../../../constants/links";
import {Grid} from "@material-ui/core";
import withState from "../../../../../../../../utils/withState";
import {apiTerminalsList} from "../../../../../../../../api/merchant/terminals";

export default withState((setState, self, onMount) => {
  const update = () => {
    setState({loading: true});

    return apiTerminalsList({offset: 0, limit: 100}).then((result) => {
      const list = (result || {}).list;

      const activeCount = list.reduce((acc, next) => {
        if (next.active) acc += 1;
        return acc;
      }, 0);

      const inactiveCount = list.length - activeCount;

      setState({activeCount, inactiveCount, loading: false});
    });
  }

  onMount(() => {
    update();
  })

  return (state) => {
    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            key={1}
            lg={6}
            xs={12}
          >
            <CardTerminals
              title="My Terminals"
              stats={[
                ['Active', (state.activeCount || 0)],
                ['Not active', (state.inactiveCount || 0)]
              ]}
              linkProps={{
                href: LINK_TERMINALS_LIST,
                text: 'Go to list'
              }}
              imgProps={{
                src: require('../../assets/termitals-my.png'),
                title: 'My Lunu Terminals'
              }}
            />
          </Grid>
          <Grid item key={2} lg={6} xs={12}>
            <CardTerminals
              title="Buy Terminal"
              info="From 50€ / Month"
              linkProps={{
                href: LINK_TERMINALS_BUY,
                text: 'Details'
              }}
              imgProps={{
                src: require('../../assets/termitals-smthg.png'),
                title: 'Buy Lunu Terminal'
              }}
            />
          </Grid>
        </Grid>
      </WrapperWithLoading>
    )
  }
})
